import { render, staticRenderFns } from "./employeeDashboard.vue?vue&type=template&id=20a8d392&scoped=true&"
import script from "./employeeDashboard.vue?vue&type=script&lang=js&"
export * from "./employeeDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a8d392",
  null
  
)

export default component.exports